import { render, staticRenderFns } from "./UdeskContact.vue?vue&type=template&id=53c79bb1&scoped=true"
import script from "./UdeskContact.vue?vue&type=script&lang=js"
export * from "./UdeskContact.vue?vue&type=script&lang=js"
import style0 from "./UdeskContact.vue?vue&type=style&index=0&id=53c79bb1&prod&lang=scss&scoped=true"
import style1 from "./UdeskContact.vue?vue&type=style&index=1&id=53c79bb1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c79bb1",
  null
  
)

export default component.exports